import gql from 'graphql-tag';

export const USER_LOGIN = gql`

  mutation userLogin($login: String!, $password: String) {
    user {
      login(input: { login: $login, password: $password }) {
        user {
          id
          email
          login
          role
          companyId
          market {
            id
            name
          }
        }
        sid
      }
    }
  }
`;

export const USER_LOGOUT = gql`
  mutation userLogout {
    user {
      logout {
        user {
          id
        }
      }
    }
  }
`;
